import { BulletinType } from '../../services/api';
import { BulletinCategory, BulletinEntry, BulletinSystem } from './types';

export const getEntryLink = (
  type?: string,
  date?: string,
  entry?: BulletinEntry | null,
) => {
  if (!type || !date || !entry) {
    return null;
  }
  const code = entry.type === 'variable' ? 'v' : 'r';
  return `/bulletin/${type}/${date}/${code}/${entry.tree_key}`;
};

export const sortOrdersFunction = (
  a: { order: number },
  b: { order: number },
) => a.order - b.order;

export const getOrderedEntries = (systems: BulletinSystem[]) =>
  systems
    .sort(sortOrdersFunction)
    .map(system =>
      system.categories
        .sort(sortOrdersFunction)
        .map(category => category.entries)
        .flat(),
    )
    .flat();

export const getPrevNextEntry = (
  orderedEntries: BulletinEntry[],
  currentEntryTreeKey: string | null,
  entryType: string = 'variable',
  type: 'prev' | 'next' = 'next',
) => {
  const currentIndex = orderedEntries.findIndex(
    entry =>
      currentEntryTreeKey &&
      entry?.tree_key === currentEntryTreeKey &&
      entry?.type === entryType,
  );
  if (currentIndex === -1) {
    return null;
  }

  const entryIndex = type === 'next' ? currentIndex + 1 : currentIndex - 1;
  const noEntryToReturn =
    (type === 'next' && entryIndex > orderedEntries.length) ||
    (type === 'prev' && entryIndex < 0);

  if (noEntryToReturn) {
    return null;
  }
  return orderedEntries[entryIndex];
};

export interface FormattedSystemType extends BulletinSystem {
  orderedCategories?: Array<BulletinCategory>;
  activeCategories?: Array<string>;
}

export function getBulletinLastValidationDate(
  bulletinTypeObject?: BulletinType[],
  bulletinType?: string,
) {
  if (!bulletinType || !bulletinTypeObject) {
    return undefined;
  }
  return bulletinTypeObject.find(item => item.code === bulletinType)
    ?.last_bulletin_date;
}
